module.exports = Object.freeze({
  UserTypes: {
    PARENT: 'Parent',
    TEACHER: 'Teacher',
    STUDENT: 'Student'
  }
})



// WEBPACK FOOTER //
// ./src/contants.js